import { Column, ContainerFlex, Row } from "../../../Components/Layout";
import { Text } from "../../../Components/Text";
import { ButtonModal } from "../../../Components/Button";
import useStatus from "../../../Hooks/Support/useStatus";

const Item = ({ item }) => {
  const { getStatus } = useStatus();

  const handleEdit = () => {
    getStatus(item.id);
  };

  return (
    <ContainerFlex
      className="card-item accordion-item shadow-sm"
      marginBottom="3"
      padding="2"
    >
      <Row>
        <Column col="12" between>
          <ContainerFlex row middle>
            <Text
              tag="h5"
              padding="0"
              margin="0"
              marginTop="1"
              fontWeight="bolder"
            >
              {item.name}
            </Text>
          </ContainerFlex>
          <ContainerFlex middle>
            <ButtonModal
              txtColor="ydental-gray"
              onClick={handleEdit}
              modal="Support_Status_Modal"
              marginRight="2"
              middle
            >
              <Text tag="i" className="fa fa-pen" />
            </ButtonModal>
          </ContainerFlex>
        </Column>
        <Column col="12">
          <Column col="12">
            <Text tag="small" className="text-muted" marginRight="2">
              Ação no chamado:
            </Text>
            <Text tag="small" fontWeight="bolder">
              {item.is_open ? "Aberto" : "Fechado"}
            </Text>
          </Column>
        </Column>
      </Row>
    </ContainerFlex>
  );
};

export default Item;
